export default __webpack_public_path__ + "static/media/saude-capilar.f18bf9c6.png";